













import { Component, Vue, Prop } from 'vue-property-decorator';
import { Mutations, Actions, Hococo } from '@/ts/store/Constants';
import ConversationData from '@/ts/ConversationData';
import PersonData from '@/ts/PersonData';
import PersonSuggestions from '@/components/PersonSuggestions.vue';
import { debounce } from 'lodash';

@Component({
    components: {
        PersonSuggestions,
    },
})
export default class MobileAddPerson extends Vue {
    @Prop() public conversation!: ConversationData;
    public searchQuery: string = '';
    public queryDebounceFunction: any | null;

    constructor() {
        super();

        this.queryDebounceFunction = debounce(() => {
            this.queryRecipients();
        }, Hococo.SUGGESTION_DEBOUNCE_PERIOD);
    }

    get suggestionsVisible() {
        return this.$store.getters['Messages/personSuggestionsVisible'];
    }

    get participants(): number[] {
        return this.conversation.recipients;
    }

    get dataLoaded(): boolean {
        return (
            this.conversation !== null
         && this.conversation.participants !== null
         && this.conversation.messages !== null
        );
    }

    public queryRecipients(): void {
        this.$store.dispatch(Actions.QUERY_PERSON_SUGGESTIONS, this.searchQuery);
        this.$store.commit(Mutations.SHOW_PERSON_SUGGESTIONS);
    }

    public getUser(userId: number): PersonData {
        return this.$store.getters['User/getCacheUser'](userId);
    }

    public mounted() {
        const key = 'input';
        this.$nextTick(() => (this.$refs[key] as HTMLInputElement).focus());
    }

    public beforeCreate() {
        this.$store.commit(Mutations.TOGGLE_SEARCH_FIELD, false);
    }

    public beforeDestroy() {
        this.$store.commit(Mutations.TOGGLE_SEARCH_FIELD, true);
    }
}
